<script setup>
import { ref } from 'vue'
import { Check, Clock, Circle, ChevronDown, Calendar } from 'lucide-vue-next'
import { paymentStatus } from '../lib/status'
import { brl } from '../lib/format'

defineProps({
  installments: { type: Array, required: true },
})

const expanded = ref(null)
const toggle = (id) => (expanded.value = expanded.value === id ? null : id)

const rowIcon = (state) => (state === 'paid' ? Check : state === 'due' ? Clock : Circle)
</script>

<template>
  <p v-if="!installments.length" class="rounded-lg border border-slate-100 px-4 py-8 text-center text-sm text-slate-500">
    Nenhuma parcela lançada nesta ordem de serviço. O financeiro da UP Aviation lança o
    cronograma assim que o serviço é fechado.
  </p>

  <ul v-else class="divide-y divide-slate-100 overflow-hidden rounded-lg border border-slate-100">
    <li v-for="item in installments" :key="item.id">
      <button
        type="button"
        class="flex w-full items-center gap-3 px-4 py-4 text-left transition-colors hover:bg-up-bg"
        :aria-expanded="expanded === item.id"
        @click="toggle(item.id)"
      >
        <span
          class="flex h-8 w-8 shrink-0 items-center justify-center rounded-full"
          :class="item.state === 'paid' ? 'bg-up-green text-white' : 'bg-slate-100 text-slate-400'"
          aria-hidden="true"
        >
          <component :is="rowIcon(item.state)" class="h-4 w-4" :stroke-width="item.state === 'paid' ? 3 : 2" />
        </span>

        <span class="min-w-0">
          <span class="block font-semibold text-up-navy">{{ item.label }}</span>
          <span class="block text-xs text-slate-500">
            {{ item.state === 'paid' ? `Pago em ${item.settled_on}` : `Vencimento ${item.due_on}` }}
          </span>
        </span>

        <span class="ml-auto flex shrink-0 items-center gap-3">
          <span class="text-right">
            <span class="block font-semibold text-up-navy">{{ brl(item.amount) }}</span>
            <span
              class="mt-0.5 inline-block rounded-md px-2 py-0.5 text-[11px] font-medium"
              :class="paymentStatus(item.state).badge"
            >{{ paymentStatus(item.state).label }}</span>
          </span>
          <ChevronDown
            class="h-4 w-4 text-slate-400 transition-transform"
            :class="expanded === item.id && 'rotate-180'"
            aria-hidden="true"
          />
        </span>
      </button>

      <div v-if="expanded === item.id" class="border-t border-slate-100 bg-up-bg px-4 py-3.5">
        <p class="text-sm leading-relaxed text-slate-600">{{ item.note }}</p>
        <p class="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500">
          <span class="flex items-center gap-1.5">
            <Calendar class="h-3.5 w-3.5" aria-hidden="true" />Vencimento {{ item.due_on }}
          </span>
          <span v-if="item.settled_on">Compensado em {{ item.settled_on }}</span>
          <span v-if="item.share">{{ item.share }}</span>
        </p>
      </div>
    </li>
  </ul>
</template>
